export default __webpack_public_path__ + "static/media/flower_img_top_conversation_2.7facfe21.png";